import { useMemo, memo } from 'react'
import { ListItem, Box, Typography, styled } from '@mui/material'
import { Timestamp } from '@weblite/ts-action/types'
import i18next from 'i18next'
import { PosInBlock } from '../../react-hooks'
import { getPadding } from '../message-wrapper/message-wrapper'
import { t } from '$i18n'
import { dateWithOffset } from '$logic/client-device/time-offset.service'

interface StyledListItemProps {
  posInBlock: PosInBlock
}
const StyledListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== 'posInBlock',
})<StyledListItemProps>`
  width: 100%;
  padding: ${({ posInBlock }) => getPadding(posInBlock, true, false)};

  margin: 0;
  &:first-of-type {
    margin-top: 6px;
  }
  &:last-child {
    margin-bottom: 6px;
  }
`

const Container = styled(Box)`
  width: fit-content;
  margin: 0 auto;
  padding: 3px 30px;
  background-color: #0000004d;
  border-radius: 21px;
`

export const DateSeparator = memo(function ({
  date,
  posInBlock,
}: {
  date: Timestamp
  posInBlock: PosInBlock
}) {
  const formattedDate = useMemo(() => {
    const messageDate = new Date(date)

    const yesterdayDate = new Date(dateWithOffset() - 86400000).toDateString()
    const isYesterday = yesterdayDate === messageDate.toDateString()
    const isToday = new Date().toDateString() === messageDate.toDateString()

    const messageYear = messageDate.toLocaleString(i18next.language, {
      year: 'numeric',
    })
    const currentYear = new Date().toLocaleString(i18next.language, {
      year: 'numeric',
    })

    return isToday
      ? t('common.today')
      : isYesterday
        ? t('common.yesterday')
        : messageDate.toLocaleString(i18next.language, {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            day: 'numeric',
            month: 'short',
            year: currentYear !== messageYear ? 'numeric' : undefined,
          })
  }, [date])

  return (
    <StyledListItem
      id={`date-separator-${date}`}
      posInBlock={posInBlock}
      disablePadding
    >
      <Container>
        <Typography color="white" variant="caption1">
          {formattedDate}
        </Typography>
      </Container>
    </StyledListItem>
  )
})
